import { createClient } from '@supabase/supabase-js';

// Default to the provided credentials
const DEFAULT_URL = 'https://endmmrzcmjyintikirmj.supabase.co';
const DEFAULT_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVuZG1tcnpjbWp5aW50aWtpcm1qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA2ODk0ODcsImV4cCI6MjA4NjI2NTQ4N30.Mtv4WHpKPZZFFWaI7gphmPFvcKwIYzWo1JC74uNp9R4';

// Safely retrieve environment variables to prevent runtime crash
// We fallback to an empty object if import.meta.env is undefined
// @ts-ignore
const env = (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : {};

const supabaseUrl = env.VITE_SUPABASE_URL || DEFAULT_URL;
const supabaseAnonKey = env.VITE_SUPABASE_ANON_KEY || DEFAULT_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase URL or Anon Key is missing. Check your environment variables.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);